import { menusUrl } from "../resources";
import postRequest from '../common/postRequest.js';
import putRequest from '../common/putRequest.js';

async function createMenu(data, restaurantId, token) {

    await postRequest.postDataWithToken(menusUrl, data, token);

}

async function updateMenu(menuId, data, token) {

    let url = `${menusUrl}/${menuId}`;

    await putRequest.putDataWithToken(url, data, token);

}

export default {
    createMenu,
    updateMenu
}